/**
 * M3X.WORKSPACE F.8 — Breadcrumb topbar.
 *
 * Per spec §2 — Module / Sub-domain / Screen chips. Each chip is a
 * clickable Link AND keyboard-navigable. `←` keyboard shortcut (F.9
 * wires it globally) jumps up one level.
 */

import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";

import { RAIL_1_MODULES } from "./Rail1";
import type { Screen, SubDomain } from "../navigation/registry";


export interface BreadcrumbProps {
  currentModule: string | null;
  currentSubDomain: SubDomain | null;
  currentScreen: Screen | null;
  locale?: "en" | "ar";
}


export function Breadcrumb({
  currentModule,
  currentSubDomain,
  currentScreen,
  locale = "en",
}: BreadcrumbProps) {
  const modEntry = RAIL_1_MODULES.find((m) => m.id === currentModule);
  if (!modEntry) return null;

  return (
    <nav
      aria-label="Breadcrumb"
      className="flex items-center gap-1 text-sm"
    >
      <Link
        to={modEntry.pathPrefix}
        className="rounded px-2 py-1 text-text-secondary hover:bg-surface-subtle"
      >
        {modEntry.id.replace("_", " ")}
      </Link>
      {currentSubDomain && (
        <>
          <ChevronRight className="h-3.5 w-3.5 text-text-tertiary" />
          <Link
            to={currentSubDomain.screens[0]?.route ?? modEntry.pathPrefix}
            className="rounded px-2 py-1 text-text-secondary hover:bg-surface-subtle"
          >
            {locale === "ar"
              ? currentSubDomain.labelAr
              : currentSubDomain.labelEn}
          </Link>
        </>
      )}
      {currentScreen && (
        <>
          <ChevronRight className="h-3.5 w-3.5 text-text-tertiary" />
          <span
            className="px-2 py-1 font-medium text-text-primary"
            aria-current="page"
          >
            {locale === "ar"
              ? currentScreen.labelAr
              : currentScreen.labelEn}
          </span>
        </>
      )}
    </nav>
  );
}


export default Breadcrumb;
